module.exports = __webpack_public_path__ + "img/protester3.e47f328b.jpeg";